exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".time-picker-input table.uib-timepicker {\n  background: white; }\n\n.time-picker-input .dropdown-menu {\n  min-width: 0; }\n\n.time-picker-input span.time-picker-value.ng-invalid {\n  background: #F9E3E3;\n  border: 1px solid #F4C6C6; }\n\n.time-picker-input span.time-picker-value.ng-valid {\n  background: #DFF5DF;\n  border-color: #BEEBBE; }\n\n.horizontal-padding-10 {\n  padding: 0px 10px; }\n\n.hide-hours-column table.uib-timepicker tbody tr td:nth-child(1),\n.hide-hours-column table.uib-timepicker tbody tr td:nth-child(2) {\n  display: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/ui/time-picker/time-picker.scss
// module id = 947
// module chunks = 1